module.exports = __webpack_public_path__ + "5b6e9fc4a8fed94227029752ab19c4c2.svg";